var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video_off"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.6523 14.4727L29.2383 17.4154V23.3007L33.6523 26.2434V14.4727Z",
    fill: "#FF5353",
    stroke: "#FF5353",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Subtract"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1113 15.3284V25.6115C10.1113 26.7724 11.0775 27.7135 12.2693 27.7135H24.1382C24.6223 27.7135 25.0692 27.5582 25.4292 27.296L10.1113 15.3284ZM26.2961 24.1663V15.1019C26.2961 13.9411 25.33 13 24.1382 13H12.2693C12.1855 13 12.1028 13.0047 12.0215 13.0137L26.2961 24.1663Z",
    fill: "#FF5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1113 15.3284L10.4192 14.9344C10.2685 14.8167 10.064 14.7952 9.89214 14.879C9.72033 14.9628 9.61133 15.1372 9.61133 15.3284H10.1113ZM25.4292 27.296L25.7235 27.7002C25.8504 27.6078 25.9265 27.4613 25.9291 27.3044C25.9318 27.1476 25.8606 26.9986 25.737 26.902L25.4292 27.296ZM26.2961 24.1663L25.9883 24.5603C26.139 24.678 26.3435 24.6995 26.5153 24.6157C26.6872 24.5319 26.7961 24.3575 26.7961 24.1663H26.2961ZM12.0215 13.0137L11.9662 12.5168C11.7642 12.5393 11.5959 12.6818 11.5404 12.8774C11.485 13.0729 11.5535 13.2826 11.7137 13.4077L12.0215 13.0137ZM9.61133 15.3284V25.6115H10.6113V15.3284H9.61133ZM9.61133 25.6115C9.61133 27.0609 10.8138 28.2135 12.2693 28.2135V27.2135C11.3411 27.2135 10.6113 26.4839 10.6113 25.6115H9.61133ZM12.2693 28.2135H24.1382V27.2135H12.2693V28.2135ZM24.1382 28.2135C24.7306 28.2135 25.2801 28.0231 25.7235 27.7002L25.1348 26.8918C24.8583 27.0933 24.514 27.2135 24.1382 27.2135V28.2135ZM25.737 26.902L10.4192 14.9344L9.8035 15.7224L25.1214 27.69L25.737 26.902ZM26.7961 24.1663V15.1019H25.7961V24.1663H26.7961ZM26.7961 15.1019C26.7961 13.6526 25.5936 12.5 24.1382 12.5V13.5C25.0663 13.5 25.7961 14.2295 25.7961 15.1019H26.7961ZM24.1382 12.5H12.2693V13.5H24.1382V12.5ZM12.2693 12.5C12.167 12.5 12.0658 12.5057 11.9662 12.5168L12.0768 13.5106C12.1398 13.5036 12.204 13.5 12.2693 13.5V12.5ZM11.7137 13.4077L25.9883 24.5603L26.604 23.7723L12.3293 12.6197L11.7137 13.4077Z",
    fill: "#FF5353"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line 5",
    x1: 7.40367,
    y1: 14.148,
    x2: 27.648,
    y2: 29.9645,
    stroke: "#FF5353",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOff);
export default __webpack_public_path__ + "static/media/video_off.064a2598ec20455ba768a03138df6dd9.svg";
export { ForwardRef as ReactComponent };